/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForVmware extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForVmware");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForVmware.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForVmware>): ServiceAccountCredentialsForVmware {
        let obj = Object.assign(new ServiceAccountCredentialsForVmware(), model);
        ServiceAccountCredentialsForVmware.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForVmware>): ServiceAccountCredentialsForVmware {
        if (!model) return null;
        return ServiceAccountCredentialsForVmware.newInstance(<ServiceAccountCredentialsForVmware> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForVmware) {
        if (!obj) return;

        models.ServiceAccountCredentialsForVmware.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForVmware): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForVmware.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * API Key. This is a required field.
     */
    api_key: string;

}
